import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Plus, Trash2, GripVertical } from 'lucide-react'

interface OpcionesEditorProps {
  opciones: string[]
  onChange: (opciones: string[]) => void
}

export function OpcionesEditor({ opciones, onChange }: OpcionesEditorProps) {
  const handleAdd = () => {
    onChange([...opciones, ''])
  }

  const handleRemove = (index: number) => {
    onChange(opciones.filter((_, i) => i !== index))
  }

  const handleChange = (index: number, value: string) => {
    const updated = [...opciones]
    updated[index] = value
    onChange(updated)
  }

  return (
    <div className="space-y-2">
      {opciones.map((opcion, index) => (
        <div key={index} className="flex items-center gap-2">
          <GripVertical className="h-4 w-4 text-muted-foreground flex-shrink-0" />
          <Input
            value={opcion}
            onChange={(e) => handleChange(index, e.target.value)}
            placeholder={`Opción ${index + 1}`}
          />
          <Button type="button" variant="ghost" size="sm" onClick={() => handleRemove(index)}>
            <Trash2 className="h-4 w-4 text-destructive" />
          </Button>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={handleAdd}>
        <Plus className="mr-2 h-4 w-4" /> Agregar opción
      </Button>
    </div>
  )
}
